import React from "react";
import Navbar from "../Components/Navbar";
import Footer from "../Components/Footer";
import ProjPicDavidHill from "../Components/ProjPicDavidHill";

const ProjectPageDavidHill = () => {
    return (
        <>
            <Navbar />
            <ProjPicDavidHill />
            <Footer />
        </>
    );
};

export default ProjectPageDavidHill;
